import { render } from "./partner-count.vue?vue&type=template&id=5d57f1e0&scoped=true"
import script from "./partner-count.vue?vue&type=script&lang=js"
export * from "./partner-count.vue?vue&type=script&lang=js"

import "./partner-count.vue?vue&type=style&index=0&id=5d57f1e0&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d57f1e0"]])

export default __exports__